<app-datatable
  [dataSourceUrl]="dtDataSourceUrl"
  [settings]="dtSettings"
  (onInit)="onDtInit($event)"
  (onAction)="onDtAction($event)"
>
  <th class="column-hide" data-data="id">Id</th>
  <th data-data="name">Név</th>
  <th data-data="systemId">Szakrendszer azonosító</th>
  <th class="yesno" data-data="examReportModifiableLater">Utólagos módosítás engedélyezett</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>
